
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#009E49","d":"M0 0h900v600H0V0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0l947 300L0 600V0z"}}),_c('path',{attrs:{"fill":"#FFD00D","d":"M0 26.1L870 300 0 573.9V26.1z"}}),_c('path',{attrs:{"fill":"#2D2D2D","d":"M0 0l450 300L0 600V0z"}}),_c('path',{attrs:{"fill":"#D3132F","d":"M0 35l397.5 265L0 565V35z"}})])
          )
        }
      }
    